package com.macrofocus.eflux.ui

import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.diagram.DiagramType
import com.macrofocus.eflux.toDateTime
import i18next.invoke
import i18next.useTranslation
import mui.material.*
import react.*
import react.dom.aria.AriaHasPopup
import react.dom.events.MouseEvent
import web.dom.ElementId
import web.html.HTMLButtonElement

val BookmarksMenuComponent = FC<BookmarksMenuProps> { props ->
    val (languageMenu, setLanguageMenu) = useState<HTMLButtonElement?>(null)
    val (t, _) = useTranslation()

    val dataLoader = props.dataLoader
    val setLocalShiftValue = props.setLocalShiftValue

    fun handleLanguageIconClick(event: MouseEvent<*, *>) = setLanguageMenu(event.currentTarget as? HTMLButtonElement)
    fun handleLanguageMenuClose(event: Any, reason: String) = setLanguageMenu(null)

    mui.material.Tooltip {
        title = ReactNode(t("appBar.bookmarks"))

        Button {
            color = ButtonColor.inherit
            onClick = ::handleLanguageIconClick
            ariaOwns = languageMenu?.let { "bookmarks-menu" } ?: "undefined"
            ariaHasPopup = AriaHasPopup.`true`

            mui.icons.material.Bookmarks {}
            Icon { fontSize = IconSize.small; +"expand_more_icon" }
        }
    }

    Menu {
        id = ElementId("bookmarks-menu")
        languageMenu?.let { anchorEl = { languageMenu } }
        open = languageMenu != null
        onClose = ::handleLanguageMenuClose

        MenuItem {
            onClick = {
                dataLoader.configuration.timeTracker.masterDateTime.value = "20220630_2355".toDateTime()
                dataLoader.lag.value = -600
                setLocalShiftValue(-600)
                dataLoader.heatmapLinks.value = null
                dataLoader.lightning.value = true
                dataLoader.diagramTypeProperty.value = DiagramType.ThreeD
                handleLanguageMenuClose(it, "")
            }
            +"Storm on June 30, 2022 @ 13:55"
        }
    }
}

external interface BookmarksMenuProps : PropsWithChildren {
    var dataLoader: DataLoader
    var setLocalShiftValue: StateSetter<Int>
}
